import classNames from 'classnames'
import { Link } from 'gatsby'
import React, { ReactNode } from 'react'

import { HighlightText } from './HighlightText'

import './SearchResult.scss'

export type Match = {
  group: 'product' | 'method' | 'blogPost' | 'solution'
  title: string
  extraSearchField1?: string
  extraSearchField2?: string
  id: string
  url: string
  icons?: ReactNode[]
}

const SearchResult = ({
  isActive,
  match,
  resultId,
  searchTerm,
}: {
  isActive?: boolean
  match: Match
  resultId: string
  searchTerm: string
}) => {
  return (
    <Link
      rel="nofollow"
      className={classNames(
        'searchResult',
        { 'searchResult--active': isActive },
        'siteSearch__resultSection',
      )}
      data-test-id={`search-result-${resultId}`}
      to={match.url}
    >
      <div className="searchResult__heading">
        <HighlightText highlight={searchTerm.split(' ')}>
          {match.title}
        </HighlightText>
      </div>
      {match.icons && <div className="searchResult__icons">{match.icons}</div>}
    </Link>
  )
}

export default SearchResult
